<template>
  <div class="video-diagnosis-status container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <el-form ref="queryForm" class="pagination-table-query-form" :inline="true" @keyup.enter.native="handleFormQuery()">
        <el-form-item label="诊断状态">
          <el-checkbox-group v-model="tableQueryParams.diagnosisStatuss">
            <el-checkbox v-for="alarmState in $type.alarmStates" :key="alarmState.id" :label="alarmState.id">{{alarmState.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
          <el-button @click="resetQueryForm()">重 置</el-button>
        </el-form-item>
      </el-form>
      <div class="pagination-table-container">
        <el-table :data="tableData"
                  ref="table"
                  v-loading="loading"
                  border element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%">
<!--          <el-table-column type="selection" width="40"></el-table-column>-->
          <el-table-column label="序号" type="index" width="60"></el-table-column>
          <el-table-column label="名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="区域" prop="regionName" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="偏色" prop="colorCast" width="50">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.colorCast === 0 ? 'normal'
                         : scope.row.colorCast === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="条纹" prop="striage" width="50">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.striage === 0 ? 'normal'
                         : scope.row.striage === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="偏暗" prop="brightLow" width="50">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.brightLow === 0 ? 'normal'
                         : scope.row.brightLow === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="偏亮" prop="brightHigh" width="50">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.brightHigh === 0 ? 'normal'
                         : scope.row.brightHigh === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="画面抖动" prop="shake" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.shake === 0 ? 'normal'
                         : scope.row.shake === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="视频丢失" prop="lost" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.lost === 0 ? 'normal'
                         : scope.row.lost === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="画面冻结" prop="freeze" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.freeze === 0 ? 'normal'
                         : scope.row.freeze === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="画面模糊" prop="blur" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.blur === 0 ? 'normal'
                         : scope.row.blur === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="对比度偏低" prop="contrastLow" width="96">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.contrastLow === 0 ? 'normal'
                         : scope.row.contrastLow === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="对比度偏高" prop="contrastHigh" width="96">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.contrastHigh === 0 ? 'normal'
                         : scope.row.contrastHigh === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="噪声" prop="noise" width="50">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.noise === 0 ? 'normal'
                         : scope.row.noise === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="黑白图像" prop="blackWhite" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.blackWhite === 0 ? 'normal'
                         : scope.row.blackWhite === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="视频剧变" prop="upheaval" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.upheaval === 0 ? 'normal'
                         : scope.row.upheaval === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
          <el-table-column label="场景变更" prop="sceneChange" width="80">
            <template slot-scope="scope">
                  <span class="circle-tag"
                        :class="scope.row.sceneChange === 0 ? 'normal'
                         : scope.row.sceneChange === 1 ? 'error'
                         : 'unknown'"
                  ></span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentPageChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="tableQueryParams.pageNum"
          :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
          :page-size.sync="tableQueryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableTotalRow">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import VideoDiagnosisStatus from './VideoDiagnosisStatus.js'
export default VideoDiagnosisStatus
</script>

<style lang="scss">
// @import "VideoDiagnosisStatus.scss";
</style>



// WEBPACK FOOTER //
// src/views/maintenance/videoDiagnosisStatus/VideoDiagnosisStatus.vue